import React, { useCallback, useEffect, useRef, useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'

import { getLocationState } from '../../utils/listPageState'
import {
    applyAppNoticeDraft,
    NEW_APP_NOTICE_DRAFT_KEY,
    readAppNoticeDraft,
} from './appNoticeDraftUtils'
import { DEFAULT_APP_NOTICE_SEARCH_SELECT } from './appNoticeFormUtils'
import AppNoticeFormPage from './AppNoticeFormPage'
import useAppNoticeFormFlow from './useAppNoticeFormFlow'

export default function NewAppNotice() {
    const history = useHistory()
    const location = useLocation()
    const locationState = getLocationState(location)
    const listCurPage = locationState.curPage || 1
    const listSearchText = locationState.searchText || ''
    const listSearchSelect = locationState.searchSelect || DEFAULT_APP_NOTICE_SEARCH_SELECT
    const listSearch = location.search || ''
    const draftKey = NEW_APP_NOTICE_DRAFT_KEY
    const [params, setParams] = useState({
        noticeId: null,
        deviceType: 'all',
        cCode: 'kr',
        title: '',
        content: '',
        image: '',
        popupImage: '',
        status: 0,
        popupStatus: 0,
        startTime: new Date(),
        endTime: new Date(),
    })
    const [push, setPush] = useState(0)
    const [saving, setSaving] = useState(false)
    const [image, setImage] = useState('')
    const [popupImage, setPopupImage] = useState('')
    const [openSnackbar, setOpenSnackbar] = useState(false)
    const [severitySnackbar, setSeveritySnackbar] = useState('info')
    const [messageSnackbar, setMessageSnackbar] = useState('')
    const [draftReady, setDraftReady] = useState(false)
    const initialDraftStateRef = useRef(null)

    if (!initialDraftStateRef.current) {
        initialDraftStateRef.current = {
            params,
            push,
        }
    }

    const handleClose = () => {
        setOpenSnackbar(false)
    }

    const showError = useCallback((message) => {
        setOpenSnackbar(true)
        setSeveritySnackbar('error')
        setMessageSnackbar(message)
    }, [])
    const listState = {
        search: listSearch,
        curPage: listCurPage,
        searchText: listSearchText,
        searchSelect: listSearchSelect,
    }
    const {
        setInitialDraftSnapshot,
        leaveGuardEnabled,
        handlers,
    } = useAppNoticeFormFlow({
        draftKey,
        draftEnabled: draftReady,
        params,
        push,
        saving,
        setParams,
        setPush,
        setImage,
        setPopupImage,
        setSaving,
        history,
        listState,
        saveConfig: {
            endpoint: '/api/v1/admin/appNotice/create',
            fallbackErrorMessage: 'App 공지사항을 등록하지 못했습니다.',
        },
        showError,
    })

    useEffect(() => {
        const storedDraft = readAppNoticeDraft(draftKey)
        const initialDraftState = initialDraftStateRef.current

        if (!initialDraftState) {
            setDraftReady(true)
            return
        }

        setInitialDraftSnapshot(initialDraftState)

        if (storedDraft) {
            const restoredDraft = applyAppNoticeDraft({
                baseParams: initialDraftState.params,
                basePush: initialDraftState.push,
                draft: storedDraft,
            })

            setParams(restoredDraft.params)
            setPush(restoredDraft.push)
        }

        setDraftReady(true)
    }, [draftKey, setInitialDraftSnapshot])

    const snackbar = {
        open: openSnackbar,
        severity: severitySnackbar,
        message: messageSnackbar,
        onClose: handleClose,
    }
    const formState = {
        params,
        push,
        image,
        popupImage,
        saving,
        leaveGuardEnabled,
        detailImageButtonLabel: '상세 이미지 업로드',
    }

    return (
        <AppNoticeFormPage
            title="App 공지사항 등록"
            formState={formState}
            listState={listState}
            snackbar={snackbar}
            handlers={handlers}
        />
    )
}
